<template>
  <div class="status-line-wrapper" :class="{ startAlign }">
    <div class="title-wrapper">
      <h3
        class="status-title"
        :class="{
          onHold: status === 'on_hold',
          capitalizeText: capitalizeText
        }"
      >
        Status: <span>{{ formatKitStatus(status) }}</span>
      </h3>
      <div class="hold-icon" v-if="reason">
        ?
        <div class="hold_reason">{{ reason }}</div>
      </div>
    </div>
    <div class="status-line" v-if="isLineShown">
      <div
        class="line"
        :class="{
          active:
            status === 'activated' ||
            status === 'lab_awaiting' ||
            status === 'lab_received' ||
            status === 'analysis_completed',
          onHold: status === 'on_hold'
        }"
      ></div>
      <div
        class="line"
        :class="{
          active:
            status === 'lab_awaiting' ||
            status === 'lab_received' ||
            status === 'analysis_completed',
          onHold: status === 'on_hold'
        }"
      ></div>
      <div
        class="line"
        :class="{
          active: status === 'lab_received' || status === 'analysis_completed',
          onHold: status === 'on_hold'
        }"
      ></div>
      <div
        class="line"
        :class="{
          active: status === 'analysis_completed',
          onHold: status === 'on_hold'
        }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusLine",
  props: {
    status: String,
    reason: String,
    isLineShown: Boolean,
    capitalizeText: Boolean,
    startAlign: Boolean
  },
  methods: {
    formatKitStatus(str) {
      return str.replace("_", " ");
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/colors";
.status-line-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: TTNormsRegular, sans-serif;
  &.startAlign {
    align-items: flex-start;
    margin-top: 6px;
    .title-wrapper {
      margin-bottom: 0;
    }
  }
  .title-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .status-title {
      text-transform: uppercase;
      font-size: 14px;
      color: $green;
      font-family: TTNormsMedium, sans-serif;
      &.onHold {
        color: orange;
      }
      &.capitalizeText {
        font-size: 16px;
        text-transform: capitalize;
      }
    }
    .hold-icon {
      width: 18px;
      height: 18px;
      color: $white;
      border-radius: 3px;
      background-color: $blue;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin-left: 10px;
      cursor: pointer;
      &:hover .hold_reason {
        display: block;
      }
      .hold_reason {
        display: none;
        position: absolute;
        top: 30px;
        width: 150px;
        height: auto;
        padding: 10px;
        border-radius: 5px;
        color: $gray;
        background-color: $lightGray;
        z-index: 2;
      }
    }
  }
  .status-line {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 10px 0 20px 0;
    position: relative;
    left: -10px;
    .line {
      width: 25%;
      left: 25%;
      height: 10px;
      position: relative;
      &:after {
        content: "";
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: $blue;
        position: relative;
      }
      &:before {
        content: "";
        display: block;
        height: 4px;
        width: 100%;
        top: 3px;
        left: calc(-100% + 10px);
        background-color: $blue;
        position: absolute;
      }
      &.active {
        &:after,
        &:before {
          background-color: $green;
        }
      }
      &.onHold {
        color: orange;
        &:after,
        &:before {
          background-color: orange;
        }
      }
    }
  }
}
</style>
